import React, { Component, Fragment } from 'react';
import { connect }        from 'react-redux';

import * as routes from '../../constants/routes';

//assets
import './favorites.scss';
import dog from 'assets/icons/no-favorites.svg';

//actions
import { getUserFavorites } from 'redux/actions';

import Benefit from 'containers/shared/benefit/benefit';
import {getMediaPath} from "../../app/functions";
// import Tabs from "../category_page/tabs";


class Favorites extends Component {
    constructor(props){
        super(props);
        this.state={
            selectedTab: "benefits",
        }
    }

    componentDidMount() {
        if (!this.props.userData){
            this.props.history.push(routes.home);
        }
        this.getFavorites();
    }

    getFavorites = () => {
        this.props.getUserFavorites();
    }

    handleOnClick = (type)=> {
        this.setState({selectedTab:type});
    }

    render() {
        let data = this.props.favorites;
        let favorites_list = [];
        let no_favorites = false;

        if(data) {
            for(let benefit in data) {
                let item = data[benefit];
                favorites_list.push(
                    <Benefit data={ item } key= { item.id } />
                );
            }
            no_favorites = Object.keys(data).length === 0;
        }

        return (
            <main className="favorites-wrapper">
                { (data && !no_favorites) &&
                <Fragment>
                    <div className="title-wrapper">
                        <h1 className="title">{ this.props.text.favorites_page_title }</h1>
                        <div className="item-amount">
                            {/*<span>{ data.length }</span>*/}
                            {/*<span>&nbsp;</span>*/}
                            {/*<span>{ this.props.text.favorites_items }</span>*/}
                            {/*<Tabs activeTab={this.state.selectedTab} handleOnClick={this.handleOnClick}/>*/}
                        </div>
                    </div>
                    <div className="result-wrapper">
                        { favorites_list }
                    </div>
                </Fragment>
                }
                { no_favorites &&
                    <div className="no-results">
                        <div className="icon">
                            <img src= { getMediaPath(dog) } alt="" />
                        </div>
                        <div className="title">{ this.props.text.still_no_favorites }</div>
                        <div className="text">{ this.props.text.no_favorites_text }</div>
                    </div>
                }
            </main>
        );
    }
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        device: store.state.deviceState,
        text: store.config.Translations,
        favorites: store.data.Favorites,
        userData: store.config.UserData,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
        getUserFavorites: (payload) => dispatch(getUserFavorites(payload)),
    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Favorites);
